import {FC, useLayoutEffect, useState} from 'react';
import {toast} from 'react-toastify';
import dayjs from 'dayjs';
//mui
import {Box, Typography} from '@mui/material';
//hooks
import {useAppDispatch, useAppSelector} from '@/store/hooks';
//services
import {OrganizationEventService} from '@/utils/services';
//store
import {getCurrentEventSelector, getEvent} from '@/store/organization-event';
import {
  AUCTION_OFFLINE,
  AUCTION_ONLINE,
  END,
  MERIDIEM_HOUR_FORMAT,
  MMM_D_YYYY,
  START,
  SUBTITLE1,
} from '@/utils/constants';
//helpers
import {getErrorMessage} from '@/utils/helpers';
//enums
import {EVENT_TYPE} from '@/utils/enums';
//icons
import {ReactComponent as CalendarIcon} from '@/assets/icons/calendar.svg';
import {ReactComponent as ClockIcon} from '@/assets/icons/clock.svg';
import {ReactComponent as ArrowRightIcon} from '@/assets/icons/arrow-line-right.svg';
//components
import MaskSwitch from '@/shared/components/Switches/MaskSwitch';
//styles
import {auctionDateInfoStyle} from './AuctionDateInfo.styles';

const AuctionDateInfo: FC = () => {
  const dispatch = useAppDispatch();
  const currentEvent = useAppSelector(getCurrentEventSelector);

  const [auctionState, setAuctionState] = useState<string>(
    currentEvent?.isOnlineAuction ? AUCTION_ONLINE : AUCTION_OFFLINE
  );

  useLayoutEffect(() => {
    if (currentEvent?.isOnlineAuction) setAuctionState(AUCTION_ONLINE);
  }, [currentEvent]);

  const handleChangeAuctionState = async (value: string) => {
    if (!currentEvent) return;
    try {
      const isOnlineAuction = value === EVENT_TYPE.AUCTION_ONLINE;
      await OrganizationEventService.updateEventType(currentEvent.id, isOnlineAuction);
      setAuctionState(value);

      await dispatch(getEvent(currentEvent!.id)).unwrap();
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };
  return (
    <Box sx={auctionDateInfoStyle.wrapper}>
      <Box
        sx={{
          ...auctionDateInfoStyle.content,
        }}
      >
        <Box sx={auctionDateInfoStyle.date}>
          <Typography
            variant={SUBTITLE1}
            sx={{
              ...auctionDateInfoStyle.title,
            }}
          >
            {START}:
          </Typography>

          <Box sx={auctionDateInfoStyle.date}>
            <Box sx={auctionDateInfoStyle.dateItem}>
              <CalendarIcon />
              {dayjs
                .utc(auctionState === AUCTION_ONLINE ? currentEvent?.startAuctionData : currentEvent?.startData)
                .format(MMM_D_YYYY)}
            </Box>

            <Box sx={auctionDateInfoStyle.dateItem}>
              <ClockIcon />
              {dayjs
                .utc(auctionState === AUCTION_ONLINE ? currentEvent?.startAuctionData : currentEvent?.startData)
                .format(MERIDIEM_HOUR_FORMAT)}
            </Box>
          </Box>
        </Box>

        <Box sx={auctionDateInfoStyle.icon}>
          <ArrowRightIcon />
        </Box>

        <Box sx={auctionDateInfoStyle.date}>
          <Typography
            variant={SUBTITLE1}
            sx={{
              ...auctionDateInfoStyle.title,
            }}
          >
            {END}:
          </Typography>

          <Box sx={auctionDateInfoStyle.date}>
            <Box sx={auctionDateInfoStyle.dateItem}>
              <CalendarIcon />
              {dayjs
                .utc(auctionState === AUCTION_ONLINE ? currentEvent?.endAuctionData : currentEvent?.endData)
                .format(MMM_D_YYYY)}
            </Box>

            <Box sx={auctionDateInfoStyle.dateItem}>
              <ClockIcon />
              {dayjs
                .utc(auctionState === AUCTION_ONLINE ? currentEvent?.endAuctionData : currentEvent?.endData)
                .format(MERIDIEM_HOUR_FORMAT)}
            </Box>
          </Box>
        </Box>
      </Box>

      <MaskSwitch
        masks={[AUCTION_OFFLINE, AUCTION_ONLINE]}
        value={auctionState}
        onChange={(value) => handleChangeAuctionState(value as string)}
      />
    </Box>
  );
};
export default AuctionDateInfo;
